import { render, staticRenderFns } from "./GtInstructions.vue?vue&type=template&id=6d6e982a"
import script from "./GtInstructions.vue?vue&type=script&lang=js"
export * from "./GtInstructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports